module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA5UlEQVQ4je3TMUqDQRAF4C9B7UxsRG9gZaWtkAtYprS1U7C2+T2DICnjGbSPIIiF3kOvoODIwG7yK39htPXBY4d5+2aHnV1/RkRUHscCDxExbmnjkquYa/1WAxs4QQ/XmOKocFpyqU2wWU29rII9HOIMVxhgiJ2y77Z1UIML3OA5C6T5CZdlwwfe8F6YWC1cY951dru/gnXc4bTjPpuynndou+ntdwjLISIGEfEYyyM9wzqmUUTMWmOrbAq/52fF82WMv8J/gcVT3sIL7nOyRcu1xvkHkjU+wDZea4GK0Q8PzpcLPgF95MwSibKcFQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yxNav.png
// module id = HS7S
// module chunks = 95